import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type Environment = 'development' | 'preview' | 'production'

export function getEnvironment(): Environment {
  if (typeof window === 'undefined') {
    if (process.env.VERCEL_ENV === 'preview') return 'preview'
    if (process.env.VERCEL_ENV === 'production') return 'production'
    if (process.env.NODE_ENV === 'development') return 'development'
    return process.env.NODE_ENV === 'production' ? 'production' : 'development'
  }

  return process.env.NODE_ENV === 'development' ? 'development' : 'production'
}

export function isDevelopment(): boolean {
  return getEnvironment() === 'development'
}

export function isPreview(): boolean {
  return getEnvironment() === 'preview'
}

export function isProduction(): boolean {
  return getEnvironment() === 'production'
}

export function isDebugMode(): boolean {
  if (process.env.NEXT_PUBLIC_DEBUG !== 'true') return false
  return !isProduction()
}

export function shouldShowDevTools(): boolean {
  const env = getEnvironment()
  return env === 'development' || env === 'preview'
}
